<template>
    <div>用户服务协议详细内容</div>
</template>

<script>
    export default {
        name: "serviceAgreement"
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/serviceAgreement.vue